import { render, staticRenderFns } from "./updatenews.vue?vue&type=template&id=5858d358&scoped=true&"
import script from "./updatenews.vue?vue&type=script&lang=js&"
export * from "./updatenews.vue?vue&type=script&lang=js&"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./updatenews.vue?vue&type=style&index=1&id=5858d358&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5858d358",
  null
  
)

export default component.exports